import React from 'react';
import { ProductTypeEditTemplate } from 'themes/application/product-type/pages';
import { observer } from 'mobx-react';
import { ProductTypeEditViewStore } from 'application/product-type/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore) => new ProductTypeEditViewStore(rootStore), 'productTypeEditViewStore')
@observer
class ProductTypeEdit extends React.Component {
    render() {
        return <ProductTypeEditTemplate {...this.props} />
    }
}

export default ProductTypeEdit;
